import React, { useContext } from 'react';

import { Box } from '@rbilabs/component-library';
import { defineMessages, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ActionLink } from 'components/action-button';
import useRoutes from 'hooks/use-routes';
import { AuthContext } from 'state/auth';
import { routes } from 'utils/routing';

export const MapContainer = styled.div<{ isDeliveryDesktop?: boolean }>`
  flex: 2;
  display: flex;
  position: relative;
  width: 100%;

  ${p =>
    p.isDeliveryDesktop &&
    `position: sticky;
    width: 100%;
    height: calc(100vh - 57px);
    top: 57px;
    // Since the maps are not draggable, changing to a default cursor makes more sense
    & * {
      cursor: default;
    }
  `}
`;

export const OrderCardScroller = styled.div`
  position: absolute;
  width: 100%;
  overflow-x: auto;
  bottom: 0;
  left: 0;

  ${Styles.desktop`
    bottom: unset;
    left: 0;
    top: 8rem;
    width: 100%;
  `}
`;

const OrderIssuesContainer = styled.div`
  color: ${Styles.color.grey.one};
  font-size: 0.875rem;
  font-style: italic;
  text-align: center;
  background-color: ${Styles.color.grey.five};
  padding: 1.25rem;
  max-width: 40rem;
`;

const OrderIssuesHeading = styled.h3`
  font-size: 1rem;
  margin: 0 0 0.625rem 0;
`;

const OrderIssuesText = styled.p`
  margin: 0;
`;

const StyledLink = styled(Link)`
  color: ${Styles.color.primary};
  text-decoration: none;
  :hover {
    color: ${Styles.color.primaryHover};
  }
`;

export const OrderIssues = () => {
  const { formatMessage } = useIntl();
  const { getLocalizedRouteForPath } = useRoutes();

  return (
    <OrderIssuesContainer>
      <OrderIssuesHeading>{formatMessage(messages.orderingIssues)}</OrderIssuesHeading>
      <OrderIssuesText>
        {formatMessage(messages.issuesDuringExperience)}
        <StyledLink to={getLocalizedRouteForPath('contact-us')}>
          {formatMessage(messages.visitSupport)}
        </StyledLink>
        .
      </OrderIssuesText>
    </OrderIssuesContainer>
  );
};

export const CTA: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { formatMessage } = useIntl();

  return isAuthenticated() ? (
    <Box margin="0 auto">
      <ActionLink to={routes.base}>{formatMessage(messages.home)}</ActionLink>
    </Box>
  ) : (
    <Box margin="0 auto">
      <ActionLink to={routes.account}>{formatMessage(messages.signUp)}</ActionLink>
    </Box>
  );
};

export const OrderCardScrollContainer = styled.div`
  padding: 1.25rem;
  display: inline-flex;
  overflow-x: visible;

  ${Styles.desktop`
    width: 100%;
    display: flex;
    justify-content: center;
  `}
`;

export const OrderCard = styled.div`
  background: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  padding: 2.25rem 2.25rem 1.438rem;
  width: calc(100vw - 3rem);
  margin-right: 1rem;

  ${Styles.desktop`
    width: 80%;
    max-width: 500px;
  `}
`;

export const SignupCard = styled(OrderCard)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  margin-right: 4rem;

  ${Styles.desktop`
    display: none;
  `}
`;

export const HeroHeading = styled.h2`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  line-height: 1;
  margin: 3.125rem auto 2.375rem;
  text-align: center;
  text-transform: uppercase;
  width: 310px;

  > small {
    text-transform: lowercase;
    vertical-align: top;
  }
`;
const messages = defineMessages({
  signUp: {
    id: 'signUp',
    defaultMessage: 'Sign Up',
    description: 'No description'
  },

  home: {
    id: 'home',
    defaultMessage: 'Home',
    description: 'No description'
  },

  visitSupport: {
    id: 'visitSupport',
    defaultMessage: ' please visit our support page.',
    description: 'No description'
  },

  issuesDuringExperience: {
    id: 'issuesDuringExperience',
    defaultMessage: 'If you experienced any issues during your ordering experience,',
    description: 'No description'
  },

  orderingIssues: {
    id: 'orderingIssues',
    defaultMessage: 'Ordering Issues?',
    description: 'No description'
  }
});
